import { RiLogoutCircleRLine } from '../../assets/icon/iconify';
import ConfirmDefaultModal from '../global/modal/confirm-default-modal';
import { useAuthActions } from '../../hooks/actions/use-auth-actions';

interface Props {
    setCollapsed: (value: boolean) => void;
    collapsed: boolean;
    setMobileSidebar: (value: boolean) => void;
}

export default function HeaderDashboard({
    setCollapsed,
    collapsed,
    setMobileSidebar,
}: Props) {

    const {
        isLoadingLogOut,
        handleLogout,
        showLogoutModal,
        setShowLogoutModal,
    } = useAuthActions();

    return (
        <>
            <header className="relative z-40 flex h-14 flex-shrink-0 items-center justify-between overflow-hidden bg-gradient-to-r from-[#186cb2] via-[#1d73ba] to-[#186cb2] px-3 text-white shadow-md sm:px-4">
                {/* SUBTLE BACKGROUND ACCENT */}
                <div className="pointer-events-none absolute inset-0 overflow-hidden">
                    <div className="absolute -left-10 -top-16 h-32 w-32 rounded-full bg-white/5" />
                    <div className="absolute left-1/3 -top-20 h-40 w-40 rounded-full bg-white/[0.03]" />
                    <div className="absolute -right-10 top-2 h-28 w-28 rounded-full bg-white/5" />
                </div>
                <div className="relative flex min-w-0 items-center gap-2 sm:gap-2.5">
                    {/* DESKTOP SIDEBAR TOGGLE */}
                    <button
                        type="button"
                        onClick={() => setCollapsed(!collapsed)}
                        className="hidden h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg border border-white/10 bg-white/5 text-white transition-all duration-200 hover:bg-white/15 hover:border-white/20 active:scale-95 md:inline-flex"
                        aria-label={ collapsed ? 'Expand sidebar' : 'Collapse sidebar' }   
                    >
                        <svg className="h-[18px] w-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" >
                            {collapsed ? (
                                <>
                                    <path d="M9 6l6 6-6 6" />
                                </>
                            ) : (
                                <>
                                    <path d="M15 6l-6 6 6 6" />
                                </>
                            )}
                        </svg>
                    </button>

                    {/* MOBILE MENU */}
                    <button
                        type="button"
                        onClick={() => setMobileSidebar(true)}
                        className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg border border-white/10 bg-white/5 text-white transition-all duration-200 hover:bg-white/15 hover:border-white/20 active:scale-95 md:hidden"
                        aria-label="Open menu"
                    >
                        <svg className="h-[19px] w-[19px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" >
                            <path d="M4 7h16" />
                            <path d="M4 12h16" />
                            <path d="M4 17h16" />
                        </svg>
                    </button>

                    {/* BRAND MARK */}
                    <div className="hidden h-8 w-px bg-white/15 sm:block" />

                    <div className="flex min-w-0 items-center gap-2.5">
                        <div className="hidden h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg border border-white/15 bg-white/10 shadow-sm sm:flex">
                            <svg className="h-4 w-4 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" >
                                <rect x="4" y="4" width="16" height="16" rx="3" />
                                <path d="M8 9h8" />
                                <path d="M8 13h5" />
                                <path d="M8 17h8" />
                            </svg>
                        </div>
                        <div className="min-w-0">
                            <div className="flex min-w-0 items-center gap-2">
                                <h1 className="truncate text-[11px] font-semibold tracking-wide sm:text-sm">
                                    {/* Insurance Franchising Proposal System */}
                                    Group Insurance System
                                </h1>
                                <span className="hidden shrink-0 rounded-full border border-white/15 bg-white/10 px-2 py-0.5 text-[8px] font-medium tracking-wide text-blue-50 lg:inline-flex">
                                    PHILLIFE
                                </span>
                            </div>
                            <div className="mt-0.5 flex items-center gap-1.5">
                                <span className="h-1.5 w-1.5 rounded-full bg-green-300 shadow-[0_0_0_2px_rgba(255,255,255,0.08)]" />
                                <p className="text-[8px] font-medium text-blue-100 sm:text-[9px]">
                                    PhilLife Financial
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* RIGHT ACTIONS */}
                {/* <div className="relative flex flex-shrink-0 items-center gap-2">
                    <div className="hidden h-6 w-px bg-white/10 sm:block" />
                    <button
                        type="button"
                        onClick={() => setShowLogoutModal(true)}
                        disabled={isLoadingLogOut}
                        className="group flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg border border-white/15 bg-white text-[#186cb2] shadow-sm transition-all duration-200 hover:bg-blue-50 hover:shadow-md active:scale-95 disabled:cursor-not-allowed disabled:opacity-60"
                        aria-label="Logout"
                        title="Logout"
                    >
                        <RiLogoutCircleRLine
                            width={18}
                            height={18}
                        />
                    </button>
                </div> */}
            </header>
            {showLogoutModal && (
                <ConfirmDefaultModal
                    modalTitle="Confirm Logout"
                    modalSubTitle="You will be signed out of your account. Do you want to continue?"
                    onCancel={() => setShowLogoutModal(false)}
                    onConfirm={handleLogout}
                    isLoading={isLoadingLogOut}
                />
            )}
        </>
    );
}